import { useState } from "react";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";


export const UseSorting = (initialData = []) => {
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: 'asc'
      });

      const handleSort = (columnKey, sortableFields) => {
        const normalizedKey = columnKey.toUpperCase().replace(/\s+/g, '_');
       
        if (!sortableFields.includes(normalizedKey)) {
          return;
        }
   
        setSortConfig((prevConfig) => {
          if (prevConfig.key === normalizedKey) {
            return {
              key: normalizedKey,
              direction: prevConfig.direction === 'asc' ? 'desc' : 'asc'
            };
          } else {
            return {
              key: normalizedKey,
              direction: 'asc'
            };
          }
        });
      };
   
    const renderSortIcon = (columnKey, sortableFields) => {
        const normalizedKey = columnKey.toUpperCase().replace(/\s+/g, '_');
       
        if (!sortableFields.includes(normalizedKey)) {
          return null;
        }
     
        const isActive = sortConfig.key === normalizedKey;
        const isAsc = sortConfig.direction === 'asc';
   
        if (!isActive) return <FaSort className="sort-icon inactive" style={{ marginLeft: 4, opacity: 0.5 }} />;
   
        return isAsc ? (
          <FaSortUp className="sort-icon active" style={{ marginLeft: 4 }} />
        ) : (
          <FaSortDown className="sort-icon active" style={{ marginLeft: 4 }} />
        );
    };
   
    const sortData = (data, sortableFields) => {
        if (!sortConfig.key || !data || data.length === 0) return data;
   
        const normalizedKey = sortConfig.key;
        const sortedData = [...data].sort((a, b) => {
          const getValue = (row, key) => {
            // Map normalized keys to actual data keys
            const keyMappings = {
              'ABBREVIATION': ['name', 'abbreviation'],
              'REPLACE_WORD': ['abbreviations', 'replace_word'],
              'NAME': ['name', 'entity_name'],
              'ALIAS_NAME': ['alias_word', 'alias_name'],
              'ANGLICIZED_NAME': ['anglicized_word', 'anglicized_name'],
              'BAD_DATA': ['special_char', 'bad_data'],
              'LETTER_CODE': ['letter', 'letter_code'],
              'REPLACE_LETTER_CODE': ['replace_letter', 'replace_letter_code'],
              'INITIALS': ['initial', 'initials'],
              'NICKNAME': ['nick_name', 'nickname'],
              'INTERVENING_WORDS': ['word_list', 'intervening_words'],
              'COUNTRY_NAME': ['country', 'country_name'],
              'UPDATED_DATE': ['updated_date', 'updatedDate']
            };
   
            const possibleKeys = keyMappings[key] || [key.toLowerCase(), key];
           
            for (const possibleKey of possibleKeys) {
              if (row[possibleKey] !== undefined && row[possibleKey] !== null) {
                return row[possibleKey];
              }
            }
            return '';
          };
   
          const aValue = getValue(a, normalizedKey);
          const bValue = getValue(b, normalizedKey);
   
          // Handle date values
          if (normalizedKey === 'UPDATED_DATE' || normalizedKey === 'CREATED_DATE') {
            const aDate = new Date(aValue);
            const bDate = new Date(bValue);
            if (!isNaN(aDate.getTime()) && !isNaN(bDate.getTime())) {
              return sortConfig.direction === 'asc'
                ? aDate - bDate
                : bDate - aDate;
            }
          }
   
          // Handle numeric values
          const aNum = parseFloat(aValue);
          const bNum = parseFloat(bValue);
          const isNumeric = !isNaN(aNum) && !isNaN(bNum) && isFinite(aNum) && isFinite(bNum);
   
          let comparison = 0;
          if (isNumeric) {
            comparison = aNum - bNum;
          } else {
            const aStr = String(aValue || '').toLowerCase();
            const bStr = String(bValue || '').toLowerCase();
            comparison = aStr.localeCompare(bStr);
          }
   
          return sortConfig.direction === 'asc' ? comparison : -comparison;
        });
   
        return sortedData;
      };
   
      const resetSort = () => {
        setSortConfig({ key: null, direction: 'asc' });
      };
   
  return {
    sortConfig,
    handleSort,
    renderSortIcon,
    sortData,
    resetSort
    }
}
